/** 카메라를 못 켰을 때 기본 문구 — 브라우저 오류 원문(영문) 대신 고정 문구(LOGISPRD-14589). 반품 화면 MESSAGES 도 이 값을 쓴다. */
export const CAMERA_UNAVAILABLE_MESSAGE = '카메라를 사용할 수 없습니다'
